export default {
  haulers: 'Trasportatori',
  setup: 'Impostare',
  driverExperience: 'Esperienza del conducente',
  users: 'Utenti',
};
